import { getSvgPointFromClient } from './tooltips'

export function renderMovingInEvents({
  events,
  svg,
  Snap,
  graph,
  mySvg,
  xOrigin,
  playerColour,
  calculateBorderLength,
  registerSelectableEventElement,
}) {
  const movingInEvents = events.filter(event => event.eventType === 'Moving_In')
  const uniqueCharacters = [
    ...new Set(movingInEvents.map(event => event.interactorID)),
  ]
  const svgBottomY = 1250
  const rowHeight = 60
  const characterRowY = {}
  uniqueCharacters.forEach((characterId, index) => {
    characterRowY[characterId] = svgBottomY + index * rowHeight
  })

  uniqueCharacters.forEach(characterId => {
    const sampleEvent = movingInEvents.find(
      event => event.interactorID === characterId
    )
    if (!sampleEvent) return
    const iconX = xOrigin - 60
    const iconY = characterRowY[characterId] - 20
    svg
      .image(
        `../../src/image/Characters/${sampleEvent.interactor}.png`,
        iconX,
        iconY,
        40,
        40
      )
      .attr({ class: 'event-icon-group' })
  })

  movingInEvents.forEach(event => {
    const playerId = `Player${event.interactorID}`
    const x = graph.getCharacterX(playerId, event.timestamp)
    const y = characterRowY[event.interactorID]
    const circle = svg.circle(x, y, 18).attr({
      fill: '#fff',
      stroke: playerColour[playerId],
      'stroke-width': 3,
      class: 'event-icon-group',
    })
    registerSelectableEventElement(circle, event, { x, y, radius: 24 })

    if (
      event.eventDetails &&
      typeof event.eventDetails === 'string' &&
      event.eventDetails.trim() &&
      event.position
    ) {
      const iconPath = `../../src/image/Location/${event.position}.svg`
      Snap.load(iconPath, function(fragment) {
        fragment.selectAll('*').forEach(function(element) {
          element.attr({ fill: null })
        })
        const iconSize = 24
        const iconGroup = svg.group()
        iconGroup.append(fragment)
        iconGroup.attr({
          transform: `translate(${x - iconSize / 2},${y - iconSize / 2})`,
          class: 'event-location-icon',
        })
        iconGroup.selectAll('svg').forEach(function(svgElement) {
          svgElement.attr({ width: iconSize, height: iconSize })
        })
      })
    }

    circle.hover(
      mouseEvent => {
        const point = getSvgPointFromClient(
          mySvg,
          mouseEvent.clientX,
          mouseEvent.clientY
        )
        const tipX = point.x + 20
        const tipY = point.y - 40
        const currentPlayer = `Player${event.interactorID}`
        const length = Math.max(
          250,
          calculateBorderLength(event.eventDetails, 50)
        )
        const tooltipWidth = Math.min(length, 600)
        const border = svg.rect(tipX, tipY, tooltipWidth, 125, 10, 10).attr({
          stroke: 'black',
          fill: 'rgba(255,255,255, 0.9)',
          strokeWidth: '3px',
        })
        const interactorText = svg.text(
          35 + tipX,
          25 + tipY,
          `Interactor: ${event.interactor}`
        )
        const interactorIcon = svg.image(
          `../../src/image/Characters/${event.interactor}.png`,
          38 + tipX,
          40 + tipY,
          40,
          40
        )
        const interactorNameElement = svg.text(
          35 + tipX,
          35 + 50 + 20 + tipY,
          event.eventDetails
        )
        const interactorBorder = svg.rect(35 + tipX, 37 + tipY, 46, 46).attr({
          fill: 'none',
          stroke: playerColour[currentPlayer],
          'stroke-width': '3',
          opacity: 0.7,
        })
        circle.data('tooltip-border', border)
        circle.data('tooltip-text', interactorText)
        circle.data('tooltip-icon', interactorIcon)
        circle.data('tooltip-name', interactorNameElement)
        circle.data('tooltip-border2', interactorBorder)
      },
      () => {
        const border = circle.data('tooltip-border')
        const interactorText = circle.data('tooltip-text')
        const interactorIcon = circle.data('tooltip-icon')
        const interactorNameElement = circle.data('tooltip-name')
        const interactorBorder = circle.data('tooltip-border2')
        if (border) border.remove()
        if (interactorText) interactorText.remove()
        if (interactorIcon) interactorIcon.remove()
        if (interactorNameElement) interactorNameElement.remove()
        if (interactorBorder) interactorBorder.remove()
      }
    )
  })
}
